export default [
  {
    path:'/importCustsomer',
    name:'importCustsomer',
    meat:{
      keepAlive:true,
      pathName:'importCustsomer',
    },
    component:resolve => require(['../view/plugin/import-customer/importCustomer'],resolve)
  },
  {
    path:'/recycle_bin',
    name:'recycle_bin',
    meat:{
      keepAlive:true,
      pathName:'recycle_bin',
    },
    component:resolve => require(['../view/plugin/recycleCustom'],resolve)
  },
  {
    path:'/transfer-capital',
    name:'transfer-capital',
    meat:{
      keepAlive:true,
      pathName:'transfer-capital',
    },
    component:resolve => require(['../view/plugin/transfer-capital/transfer-capital'],resolve)
  },
  {
    path: '/customer_cost',
    name: 'cost',
    meta: {keepAlive: true, pathName: 'cost',},
    component: resolve => require(['../view/plugin/customerCost/index'], resolve),
    children:[
      {
        path:'/cusc',
        name:'cusc',
        meta: {keepAlive: true, pathName: 'cusc',},
        component: resolve => require(['../view/plugin/customerCost/cusc'], resolve),
      },
      {
        path:'/clicks',
        name:'clicks',
        meta: {keepAlive: true, pathName: 'clicks',},
        component: resolve => require(['../view/plugin/customerCost/clicks'], resolve),
      },
      {
        path:'/exposure',
        name:'exposure',
        meta: {keepAlive: true, pathName: 'exposure',},
        component: resolve => require(['../view/plugin/customerCost/exposure'], resolve),
      }
    ],
  },
  {
    path:'/sms',
    name:'sms/account',
    meat:{
      keepAlive:true,
      pathName:'sms',
    },
    component:resolve => require(['../view/plugin/sms/sms'],resolve),
    children:[
      {
        path:'account',
        name:'account',
        meta:{
          keepAlive:true,
          pathName:'account'
        },
        component:resolve => require(['../view/plugin/sms/account'],resolve)
      },
      {
        path:'record',
        name:'record',
        meta:{
          keepAlive:true,
          pathName:'record'
        },
        component:resolve => require(['../view/plugin/sms/record'],resolve)
      }
    ]
  },
  {
    path:'/report',
    name:'report',
    component:resolve => require(['../view/plugin/report/index'],resolve),
    children:[
      {
        path:'promotion',
        name:'promotion',
        component:resolve => require(['../view/plugin/report/promotion'],resolve),
        children:[
          {
            path:'/promotion/index',
            name:'promotion_index',
            component: resolve => require(['../view/plugin/report/promotion_index'], resolve),
          },
          {
            path:'/promotion/channel',
            name:'promotion_channel',
            component: resolve => require(['../view/plugin/report/promotion_channel'], resolve),
          },
          {
            path:'/promotion/statistics',
            name:'promotion_statistics',
            component: resolve => require(['../view/plugin/report/promotion_statistics'], resolve),
          },
          {
            path:'/promotion/advertising',
            name:'promotion_advertising',
            component: resolve => require(['../view/plugin/report/promotion_advertising'], resolve),
          },
          {
            path:'/promotion/consultation',
            name:'promotion_consultation',
            component: resolve => require(['../view/plugin/report/promotion_consultation'], resolve),
          },
          {
            path:'/promotion/invalid',
            name:'promotion_invalid',
            component: resolve => require(['../view/plugin/report/promotion_invalid'], resolve),
          },
          {
            path:'/promotion/month',
            name:'promotion_month',
            component: resolve => require(['../view/plugin/report/promotion_month'], resolve),
          },
          {
            path:'/promotion/city',
            name:'promotion_city',
            component: resolve => require(['../view/plugin/report/promotion_city'], resolve),
          },
          {
            path:'/promotion/province',
            name:'promotion_province',
            component: resolve => require(['../view/plugin/report/promotion_province'], resolve),
          },
          {
            path:'/promotion/keyword',
            name:'promotion_keyword',
            component: resolve => require(['../view/plugin/report/promotion_keyword'], resolve),
          },
          {
            path:'/promotion/year',
            name:'promotion_year',
            component: resolve => require(['../view/plugin/report/promotion_year'], resolve),
          },
        ],
      },
      {
        path:'invite',
        name:'invite',
        component:resolve => require(['../view/plugin/report/invite'],resolve),
        children:[
          {
            path:'/invite/index',
            name:'invite_index',
            component:resolve => require(['../view/plugin/report/invite_index'],resolve),
          },
          {
            path:'/invite/analysis',
            name:'invite_analysis',
            component:resolve => require(['../view/plugin/report/invite_analysis'],resolve),
          },
          {
            path:'/invite/state',
            name:'invite_state',
            component:resolve => require(['../view/plugin/report/invite_state'],resolve),
          },
        ]
      },
      {
        path:'finance',
        name:'finance',
        component:resolve => require(['../view/plugin/report/finance'],resolve),
        children:[
          {
            path:'/finance/index',
            name:'finance_index',
            component:resolve => require(['../view/plugin/report/finance_index'],resolve),
          },
          {
            path:'/finance/month',
            name:'finance_month',
            component:resolve => require(['../view/plugin/report/finance_month'],resolve),
          }
        ]
      },
      {
        path:'store',
        name:'store',
        component:resolve => require(['../view/plugin/report/store'],resolve),
        children:[
          {
            path:'/store/index',
            name:'store_index',
            component:resolve => require(['../view/plugin/report/store_index'],resolve),
          }
        ]
      },
      {
        path:'introduce',
        name:'introduce',
        component:resolve => require(['../view/plugin/report/introduce'],resolve),
        children:[
          {
            path:'/introduce/index',
            name:'introduce_index',
            component:resolve => require(['../view/plugin/report/introduce_index'],resolve),
          },
          {
            path:'/introduce/count',
            name:'introduce_count',
            component:resolve => require(['../view/plugin/report/introduce_count'],resolve),
          },
          {
            path:'/introduce/staff',
            name:'introduce_staff',
            component:resolve => require(['../view/plugin/report/introduce_staff'],resolve),
          },
          {
            path:'/introduce/month',
            name:'introduce_month',
            component:resolve => require(['../view/plugin/report/introduce_month'],resolve),
          },
          {
            path:'/introduce/regular',
            name:'introduce_regular',
            component: resolve => require(['../view/plugin/report/introduce_regular'], resolve),
          },,
          {
            path:'/introduce/year',
            name:'introduce_year',
            component: resolve => require(['../view/plugin/report/introduce_year'], resolve),
          },
        ]
      },
      {
        path: '/report/others/index',
        name: 'others_index',
        component: resolve => require(['../view/plugin/report/others_index'], resolve),
        children:[
          {
            path: '/report/others/repeat',
            name: 'others_repeat',
            component: resolve => require(['../view/plugin/report/others_repeat'], resolve),
          }, {
            path: '/report/others/contact',
            name: 'others_contact',
            component: resolve => require(['../view/plugin/report/others_contact'], resolve),
          },
          {
            path: '/report/others/weChat',
            name: 'others_weChat',
            component: resolve => require(['../view/plugin/report/others_weChat'], resolve),
          }
        ]
      },
    ]
  },
]



// WEBPACK FOOTER //
// ./src/router/plugin.js